import config from '../config/config'
import axios from 'axios'
import { getToken } from '../common'; 

export const updateUserProfileAPI = async (params) => {

    return await axios({
        method  : 'patch',
        url     : `${config.api.base_url}profile`,
         data    : params,
        headers : {
            "Content-type": "application/json; charset=UTF-8",
            "Authorization": getToken(),
        }
    })
}

export default updateUserProfileAPI